import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OverdueInvoiceCard } from './OverdueInvoiceCard';
import { Carousel, CarouselItem } from '../Carousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OverdueInvoicesOverview({
  contactFirstName,
  overdueInvoices
}) {
  const manualInvoices = overdueInvoices.filter(inv => !inv.isAutomaticPaymentCollection);
  if (manualInvoices.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "overdue-invoices-section",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-500",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "invoices.greeting",
          options: {
            name: contactFirstName
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: manualInvoices.length === 1 ? 'invoices.overdueWarning.one' : 'invoices.overdueWarning.other',
          options: {
            count: manualInvoices.length
          }
        })
      })]
    }), /*#__PURE__*/_jsx(Carousel, {
      "aria-label": "Overdue invoices",
      children: manualInvoices.map(invoice => /*#__PURE__*/_jsx(CarouselItem, {
        children: /*#__PURE__*/_jsx(OverdueInvoiceCard, {
          invoice: invoice
        })
      }, invoice.invoiceNumber))
    })]
  });
}